import React, { useState } from 'react';
import PropTypes from 'prop-types';
import {getText} from 'helpers/text-helper';
import Button from 'components/ui/button/button';
import './login-facilitator.scss';

const LoginFacilitator = (props) => {
	/* Props */
	const {cookiesAccepted, languageId, deviceInfo, toggleCookiePopup, facilitatorLogin, setFacilitatorAction} = props;

	/* Loading state */
	const [isLoading, setIsLoading] = useState(false);

	/* E-mail */
	const [email, setEmail] = useState(null);

	/* Password */
	const [password, setPassword] = useState(null);

	/* Err msg */
	const [errMsg, setErrMsg] = useState(null);

	/**
	 * Handle email input
	 * @param {object} event 
	 */
	const handleEmailInput = (event) => {
		setEmail(event.target.value);
	};

	/**
	 * Handle password input
	 * @param {object} event 
	 */
	const handlePasswordInput = (event) => {
		setPassword(event.target.value);
	};

	/**
	 * Login with email and password
	 */
	const handleFacilitatorLogin = (event) => {
		if (event) event.preventDefault();

		if (!cookiesAccepted) {
			toggleCookiePopup(true);
		} else if (!email || email.length === 0 || !password || password.length === 0) {
			setErrMsg(getText('errors_missingFields', languageId));
		} else {
			setIsLoading(true);
			facilitatorLogin(email, password).catch((error) => {
				let newErrMsg = getText('errors_invalidEmailPassword', languageId);
				if (error.code === 'auth/invalid-email') {
					newErrMsg = getText('errors_invalidEmail', languageId);
				} else if (error.code === 'auth/user-not-found') {
					newErrMsg = getText('errors_emailNotFound', languageId);
				} else if (error.code === 'auth/wrong-password') {
					newErrMsg = getText('errors_invalidEmailPassword', languageId);
				}
				setErrMsg(newErrMsg);
				setIsLoading(false);
			});
		}
	};

	return (
		<div className={'LoginFacilitator ' + deviceInfo.orientation}>
			<form className='LoginFacilitator-loginForm' onSubmit={handleFacilitatorLogin}>
				<div className='LoginFacilitator-title'>
					<span>{getText('general_title', languageId)}</span>
				</div>
				<div className='LoginFacilitator-subtitle'>
					<span>{getText('general_subtitle', languageId)}</span>
				</div>
				{/* Login title */}
				<div className='LoginFacilitator-loginTitle'>
					<span>{getText('general_login', languageId)}</span>
				</div>
				{/* Email */}
				<input
					className='LoginFacilitator-input'
					name="email"
					type="text"
					placeholder={getText('general_email', languageId)}
					autoComplete="section-facilitatorlogin email"
					value={email ? email : ''} 
					onChange={(event)=>{handleEmailInput(event);}}
				/>
				{/* Password */}
				<input
					className='LoginFacilitator-input'
					name="password"
					type="password"
					placeholder={getText('general_password', languageId)}
					autoComplete="section-facilitatorlogin password"
					value={password ? password : ''} 
					onChange={(event)=>{handlePasswordInput(event);}}
				/>
				{/* Reset btn */}
				<div 
					className='LoginFacilitator-resetPassword'
					onClick={() => {setFacilitatorAction('reset-password');}}
				>
					<span>{getText('general_forgottenPassword', languageId)}</span>
				</div>
				<div className='LoginFacilitator-buttons'>
					{/* Create user btn */}
					<div className='LoginFacilitator-button'>
						<Button
							classes={['orange', 'fullHeight']}
							text={getText('general_createUser', languageId)}
							onClick={() => {setFacilitatorAction('create-user');}}
						/>
					</div>
					{/* Login btn */}
					<div className='LoginFacilitator-button'>
						<Button
							type="submit"
							isLoading={isLoading}
							classes={['orange', 'login', 'fullHeight']}
							text={getText('general_login', languageId)}
						/>
					</div>
				</div>
				<div className='LoginFacilitator-errMsg'><span>{errMsg}</span></div>
			</form>
		</div>
	);
};

LoginFacilitator.propTypes = {
	cookiesAccepted: PropTypes.bool.isRequired,
	languageId: PropTypes.string.isRequired,
	deviceInfo: PropTypes.object.isRequired,
	toggleCookiePopup: PropTypes.func.isRequired,
	facilitatorLogin: PropTypes.func.isRequired,
	setFacilitatorAction: PropTypes.func.isRequired
};

export default LoginFacilitator;